import Client from './client'

const EVENT_NAME = 'translated_policy_view'
const URL = 'v1/events'


export default function postTranslatedPolicyEvent({ identity, language, policyType, viewMethod, websiteUUID }) {
  return Client.post(URL, {
    event_name: EVENT_NAME,
    identity,
    properties: {
      account_id: websiteUUID,
      language,
      policy_type: policyType,
      view_method: viewMethod,
    },
  })
}
